var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isSuperAdmin || _vm.isAdmin || _vm.isDistributor)?_c('admin-dashboard'):_c('user-dashboard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }